const NavigationRoutes = {
  home: '/md/dashboard__a/tb/dash_home__a/stb/default/reporting/dash_home__a',
} as const;

export default NavigationRoutes;
